import { SxProps, Theme } from '@mui/material/styles';

export const titleDpCarouselContentMainSX: SxProps<Theme> = {
	fontWeight: '800',
	fontSize: {
        xs: 'var(--font-size-xl)',
        sm: 'var(--font-size-display)',
    },
    textAlign: 'start',
    color: '#FFF',
};

export const titleDpCarouselContenSecondarytSX: SxProps<Theme> = {
	fontWeight: '800',
	fontSize: {
        xs: 'var(--font-size-lg)',
        sm: 'var(--font-size-xxl)',
    },
    textAlign: {
        xs: 'center',
        sm: 'start',
    },
    color: 'text.primary',
};

export const descriptionDpCarouselContentMainSX: SxProps<Theme> = {
	fontWeight: '600',
	fontSize: {
        xs: 'var(--font-size-body)',
        sm: 'var(--font-size-lg)',
    },
    textAlign: 'start',
    color: '#FFF',
};


export const descriptionDpCarouselContenSecondarytSX: SxProps<Theme> = {
	fontWeight: 'normal',
	fontSize: {
        xs: 'var(--font-size-default)',
        sm: 'var(--font-size-body)',
    },
    textAlign: {
        xs: 'center',
        sm: 'start',
    },
    color: 'text.primary',
};
